import {
  useTranslation,
  withTranslation,
} from "react-i18next";
import i18n, {
  I18nNamespace,
  normalizeLanguage,
  SupportedLanguage,
} from "./index";

export const useAppTranslation = (
  ns?: I18nNamespace | I18nNamespace[],
  options?: any
) => {
  const translation = useTranslation(ns, options);
  const currentLanguage = normalizeLanguage(
    translation.i18n.resolvedLanguage || i18n.resolvedLanguage
  );

  return {
    ...translation,
    currentLanguage,
    changeLanguage: (lng: SupportedLanguage) =>
      translation.i18n.changeLanguage(lng),
  };
};

export { withTranslation };
